import React from 'react';
import { DetailedBanner } from '@qga/roo-ui/components';

import { X_SELL_BANNER_URL } from '@/config/public';
import hotelBed from './assets/hotel-bed.svg';

const XSellBanner = () => {
  if (!X_SELL_BANNER_URL) {
    return null;
  }

  return (
    <>
      <DetailedBanner
        icon={{
          src: hotelBed,
          alt: 'Hotel Bed',
        }}
        heading="Just need a hotel?"
        cta={{
          type: 'text',
          label: 'VIEW HOTEL ONLY DEALS',
          iconName: 'launch',
          onClick: () => window.open(X_SELL_BANNER_URL),
        }}
        layout="row"
      >
        Find similar offers with Qantas Hotels.
      </DetailedBanner>
    </>
  );
};

export default XSellBanner;
